/**
 * Deterministic avatar colours: the same person always gets the same colour, so an agent or an
 * administrator is recognisable at a glance in lists, modals and panels. Pure functions, no I/O.
 */
const PALETTE: ReadonlyArray<{ bg: string; fg: string }> = [
  { bg: "#e0f2fe", fg: "#075985" },
  { bg: "#dcfce7", fg: "#166534" },
  { bg: "#fef3c7", fg: "#92400e" },
  { bg: "#fce7f3", fg: "#9d174d" },
  { bg: "#ede9fe", fg: "#5b21b6" },
  { bg: "#ffedd5", fg: "#9a3412" },
  { bg: "#ccfbf1", fg: "#115e59" },
  { bg: "#fee2e2", fg: "#991b1b" },
];

/** Small stable hash (djb2) of the seed, never negative. */
function hash(seed: string): number {
  let h = 5381;
  for (let i = 0; i < seed.length; i++) {
    h = ((h << 5) + h + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function avatarColors(seed: string | null | undefined): { bg: string; fg: string } {
  const key = (seed ?? "").trim().toLowerCase();
  return PALETTE[hash(key) % PALETTE.length];
}

/** Up to two letters: first letters of the first two words, else the first two letters. */
export function avatarInitials(name: string | null | undefined): string {
  const source = (name ?? "").trim();
  if (!source) {
    return "?";
  }
  const parts = source.split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return source.slice(0, 2).toUpperCase();
}
